
<style>
    .barChart{
        width: 100%;
        height: 350px;
        display: inline-block;
        background-color: #1e094e;
        box-shadow: 0 2px 12px 0 rgba(30,9,78, 1);
    }
    .ratio_class{
		height: 450px !important;
	}
	@media screen and (min-width:2200px){
		.ratio_class{
			height: 600px !important;
		}
	}
</style>

<template>
    <div>
        <div :class="{ratio_class : useData.id == 'barChart4'}"   class="barChart Chart" :id="useData.id"></div>
    </div>
</template>
<script>
    export default {
        name: 'barChart',
        props: ['dataBol','useData','widthPxMess'],
        data(){
            return {
                
            }
        }, 
        watch: {
            'dataBol': {
                handler (n) {
                    let _this = this;
                    if(n){
                        let myChart = _this.$echarts.init(document.getElementById(_this.useData.id));
                        _this.myChart = myChart;
                        _this.drawChart();  
                    }
                }
            }
        },
        methods: {
            drawChart(){
                let _this = this;
                _this.myChart.setOption({
                    title:{
                        text:_this.useData.title,
                        textStyle:{
                            color: '#ffffff',
                            fontWeight: 'bold',
                            fontSize:_this.widthPxMess.titleSize
                        },
                        x:'center',
                        y:'20',
                    },
                    grid:{
                        top:'25%',
                    },
                    legend: {
                        show:_this.useData.bzBol,
                        icon:'none',
                        textStyle:{
                            color: '#a9a5b5',
                            fontSize:_this.widthPxMess.XYSize
                        },
                        formatter: function () {
                            return '貨幣單位：HKD(W)'
                        },
                        right: 20,
                        top:'15%'
                    },
                    animation: true,
                    xAxis: {
                        
                        data: _this.useData.x,
                        axisTick:{
                            show:false,
                        },
                        axisLine: {
                            show:false,
                            lineStyle: {
                                color: '#ccc'
                            }
                        },
                        axisLabel:{
                            interval:0,
                            fontSize:_this.widthPxMess.XYSize,
                        }
                    },
                    yAxis: {
                        name: '人數',
                        nameTextStyle: {
                            padding: [0, 30, 0, 0]    // 四个数字分别为上右下左与原位置距离
                        },
                        axisTick:{
                            show:false,
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: '#311878',
                                type: 'dashed'
                            }
                        },
                        axisLine: {
                            show:false,
                            lineStyle: {
                                color: '#ccc',
                            }
                        },
                        axisLabel:{
                            interval:0,
                            fontSize:_this.widthPxMess.XYSize
                        },
                        minInterval:1,
                    },
                    series: [{
                        name: 'bar',
                        type: 'bar',
                        barWidth: 20,
                        itemStyle: {
                            barBorderRadius: [20,20,0,0],
                            color: new _this.$echarts.graphic.LinearGradient(
                                0, 0, 0, 1,
                                [
                                    {offset: 0, color: '#2477fb'},
                                    {offset: 1, color: '#1f2376'}
                                ]
                            ),
                            opacity:0.7
                        },
                        data: _this.useData.data
                    }]
                })
            }
        }
    }
</script>